import { AuthForm } from "../components/auth-form";

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br bg-[#8b181c] via-background to-muted p-4">
      <div className="w-full max-w-4xl">
        {/* Toggle Button */}
        <AuthForm />
      </div>
    </div>
  );
}
